import React, {Component} from 'react';
import {Form} from '@shopify/polaris';

export const CsValidationContext = React.createContext();

class CsValidationForm extends Component {

    static _forms = new Map();

    // todo: Should have a removeForm on destruction
    static addForm(name, obj) {
        CsValidationForm._forms.set(name, obj);
    }

    static validate(name) {
        if (name === "" || CsValidationForm._forms.has(name) === false) {
            throw new Error('Validation form name missing! ' + name);
        }
        let obj = CsValidationForm._forms.get(name);
        if (obj === null || obj === undefined) {
            throw (new Error('Invalid name!'));
        }

        return obj.doValidate();
    }

    constructor(props) {
        super(props);
        this.formChildren = [];
        this.lastValidatorChild = undefined;
        if (!this.props.hasOwnProperty('name') || this.props.name === "")
            return;
        CsValidationForm.addForm(this.props.name, this);
    }

    static defaultProps = {
        realtime: false,
        onSubmit: (event) => {}
    }

    addValidator = (obj) => {
        this.formChildren.push(obj);
        if (this.props.realtime && obj.hasOwnProperty('doValidation')) {
            this.lastValidatorChild = obj;
        }
        // console.log('---addValidator', this.lastValidatorChild, this.formChildren.length, this.formChildren);
    }

    removeValidator = (obj) => {
        const index = this.formChildren.indexOf(obj);
        if (index !== -1) {
            this.formChildren.splice(index, 1);
            if (this.props.realtime) {
                this.lastValidatorChild = this.formChildren.slice().reverse().find(item => item.hasOwnProperty('doValidation'))  
            }
            // console.log('---removeValidator', this.lastValidatorChild, this.formChildren.length, this.formChildren);
        }
    }
    
    doValidatePrevEls = (obj) => {
        // console.log('---doValidatePrevEls', obj);
        const index = this.formChildren.indexOf(obj);
        if (index !== -1) {
            const prevEls = this.formChildren.slice(0, index);
            // console.log('-----doValidatePrevEls', index, prevEls);
            for (const ele of prevEls) {
                ele.hasOwnProperty('doValidation') && ele.doValidation();
            }
        }
    }
    
    lastChildIsValidator = () => {
        if (this.lastValidatorChild && this.formChildren.length) {
            return this.lastValidatorChild === this.formChildren[this.formChildren.length - 1];
        }
        return false;
    }
    
    getLastValidator = () => {
        return this.lastValidatorChild;
    }

    doValidate = () => {
        for (const item of this.formChildren) {
            if (item.hasOwnProperty('doValidation') && (item.doValidation() === false)) {
                return false;     
            }
        }
        return true;
    }

    handlerSubmit = (event) => {
        const {onSubmit} = this.props;
        if (this.doValidate() === false) {

            console.log("CsValidationForm : Submit is stoped!.")
            event.preventDefault();
            return;
        }

        onSubmit(event);
    }

    // componentWillReceiveProps(nextProps) {
    //     console.log("validateform.componentWillReceiveProps");
    // }

    getContext() {
        return {
            addValidator: this.addValidator,
            removeValidator: this.removeValidator,
            realtime: this.props.realtime,
            doValidatePrevEls: this.doValidatePrevEls,
            lastChildIsValidator: this.lastChildIsValidator,
            getLastValidator: this.getLastValidator,
        };
    }

    render() {
        let { onSubmit, ...props} = this.props;
        //let props2 = props.filter(item => item !== 'onSubmit');
        return (
            <CsValidationContext.Provider value={this.getContext()}>
                <Form  {...props} noValidate onSubmit={this.handlerSubmit}>
                    {this.props.children}
                </Form>
            </CsValidationContext.Provider>
        )
    }
}

export default CsValidationForm;
